import React from 'react';
import { Link } from 'react-router-dom';

const FluxFooter = () => {
  return (
    <footer className="flux-footer">
      <div className="flux-content-container">
        <div className="flux-footer-top">
          <Link
            to="/"
            className="flux-logo"
            aria-label="Return to the FluxSpaces home page"
          >
            <img src="/logo.png" alt="FluxSpaces" className="flux-logo-image" />
            <span className="flux-logo-text">FluxSpaces</span>
          </Link>
          <nav className="flux-footer-links" aria-label="Legal information">
            <Link to="/impressum">Legal Notice</Link>
            <Link to="/datenschutz">Privacy Notice</Link>
            <Link to="/cookies">No-Cookie Policy</Link>
            <a href="/credits.html">Open Source &amp; Credits</a>
            <a href="/eula.html">EULA</a>
          </nav>
        </div>
        <div className="flux-footer-bottom">
          <p className="flux-footer-text">
            Built for macOS 11+ • Designed for productivity
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FluxFooter;
